import React from 'react';

export default function CommentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      fill="none"
      viewBox="0 0 22 20"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.481"
        d="M17.667 1.325c.884 0 1.732.325 2.357.904.625.579.976 1.364.976 2.183v8.23c0 .819-.351 1.604-.976 2.183a3.474 3.474 0 01-2.357.904H12.11l-5.555 3.086v-3.087H4.333a3.474 3.474 0 01-2.357-.903A2.975 2.975 0 011 12.642v-8.23c0-.819.351-1.604.976-2.183a3.473 3.473 0 012.357-.904h13.334z"
      ></path>
    </svg>
  );
}